import { module } from "angular";
import { AccountRepository } from "./AccountRepository";

module("mmAuth").service("mmAccountRepository", AccountRepository);
